// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router"
import Vuetify from "vuetify"
import axios from "axios"
//import Auth from "./Auth"
//import store from "./store"
//import { securityCheckUrl, getHeader } from "@/config"
//import VueCookies from "vue-cookies"

//const vuetifyOptions = { }

//Vue.use(VueCookies)
Vue.config.productionTip = false
Vue.use(Vuetify)
//Vue.use(Auth)

/*if (window.location.protocol !== "https:") {
  window.location.href = "https://osp.kndi.institute"
}*/

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  //store,
  //vuetify: new Vuetify(vuetifyOptions),
  components: { App },
  template: "<App/>"
})



// WEBPACK FOOTER //
// ./src/main.js